import React, { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import SectionHeader from "@root/components/section-header/sectionheader";
import { TopHeader } from "@root/components/DashboardTopHeader/topheader";
import { useTranslation } from "react-i18next";
import ReportsGrid from "./reports";
import Header from "./header";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import ReportsList from "@root/components/ReportList.tsx/reportlist";
import CategoryTabs from "./dashboardtabs";

export const DashboardPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showReports, setShowReports] = useState(false);
  const isLoggedInUser: any = useSelector(getLoggedInUser);
  const { t } = useTranslation("common");
  function handleViewAll(): void {
    setShowReports(true);
  }

  console.log("base url test", process.env.REACT_APP_BASE_URL);

  const formatName = (name: string) =>
    name?.charAt(0)?.toUpperCase() + name?.slice(1);

  return (
    <Flex
      flexDirection={"column"}
      width="100%"
      height="100%"
      padding="24px"
      gap="24px"
      overflow="hidden"
    >
      <TopHeader
        profilePic={isLoggedInUser?.avatar}
        name={formatName(isLoggedInUser?.fullname)}
        onBellClick={() => alert("Bell clicked!")}
        onSearch={setSearchQuery}
        hidden
      />

      <Header name={formatName(isLoggedInUser?.fullname)} />

      <Box flex={1} minHeight={0}>
        <CategoryTabs />
      </Box>
    </Flex>
  );
};
